<template>
                <div  v-for="(vr) in validationResults">
                    <span v-if="!vr.valid" class="text-danger" >{{vr.message}}</span>
                    <span v-else-if="vr.valid" class="text-success" >{{vr.message}}</span>
                </div>
</template>

<script lang="ts">
import { Inject, Options, Prop, Vue, Watch } from 'vue-property-decorator';  
import { FieldValidationResult} from './Forms';
 
export default class ValidationResults extends Vue
{
 
   @Prop() public validationResults!: FieldValidationResult[];

}

</script>